module.exports = __webpack_public_path__ + "static/media/asc-noneOption.3b2362f2.svg";